import React, { Component } from "react";
import _ from "lodash";
import { NavLink } from 'react-router-dom';
import {formatMoney} from "accounting-js";
//import Pagination from 'react-js-pagination';
import InmPagination from "../../elements/widgets/inmPagination";
import Loading from "../loading";

export default class ProjectsList extends Component {
	render(){
		const { list, isFetching, pages } = this.props;
		let tableBody = _.map(list, (row, k) => {
			return (
				<tr key={`project-${k}`}>
					<td>
						<div className="actions">
							<NavLink to={`/proyectos/editar/datos/${row.id}`}><i className="fa fa-edit" /></NavLink>
						</div>
						{row.id}
					</td>
					<td>{row.code ? row.code : <span className="has-text-danger">N/D</span>}</td>
					<td><strong>{row.name}</strong></td>
					<td><a onClick={() => this._handleFilters(row.modality.id)}>{row.modality.name}</a></td>
					<td>{row.agency.agenciable.name}</td>
					<td>{formatMoney(row.amounts.total)}</td>
					<td>{formatMoney(row.amounts.spent)}</td>
				</tr>
			)
		});

		return [
			isFetching ? <Loading key="projects-loading" />:
				<table className={`inm-table`} key="projects-table">
					<thead>
					<tr>
						<th>ID</th>
						<th>Folio</th>
						<th style={{width:'50%'}}>Nombre</th>
						<th><a onClick={() => this._handleFilters('')}>Modalidad</a></th>
						<th>Instancia</th>
						<th>Aprobado</th>
						<th>Ejercido</th>
					</tr>
					</thead>
					<tbody>
						{tableBody}
					</tbody>
				</table>,
			(!_.isEmpty(list) && pages.total > 20) &&
			<InmPagination key="projects-pages"
			               current={pages.current}
			               total={pages.total}
			               nextPage={this._handlePageChange}/>
		]
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(page) {
		//console.log('page===>', page);
		this.props.fetchProjectsList(page, this.props.filters);
	}

	_handleFilters(modality) {
		let newFilters = this.props.filters;
		_.assign(newFilters, {modality_id: modality});
		//console.log('filters===>', newFilters);
		this.props.change('projects.filters.modality_id', modality);
		//this._handlePageChange(1);
		this.props.fetchProjectsList(1, newFilters);
	}
}



// WEBPACK FOOTER //
// ./src/elements/projects/index.jsx